import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="sobre" className="relative overflow-hidden" data-id="element-15">
      {/* PART 1 — Intro personal (2 columns) */}
      <div className="py-20 bg-white" data-id="element-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-18">
            {/* Left: Photo */}
            <div className="flex-shrink-0 text-center" data-id="element-19">
              <div className="w-36 h-36 md:w-44 md:h-44 rounded-full overflow-hidden border-4 border-inkova-accent/40 shadow-xl mx-auto" data-id="element-20">
                <img src="https://cdn.magicpatterns.com/uploads/2CHjetpnkDCC1RLRC8NFxb/WhatsApp_Image_2026-04-10_at_1.42.14_PM.jpg" alt="Annysol Navarro — Fundadora de Inkova LLC" className="w-full h-full object-cover" data-id="element-21" />
              </div>
              <h3 className="text-xl font-serif font-bold text-inkova-primary mt-4" data-id="element-22">
                Annysol Navarro
              </h3>
              <p className="text-sm text-inkova-accent font-medium tracking-wide" data-id="element-23">
                Fundadora de Inkova LLC · Guía para emprendedores latinos
                en&nbsp;EE.&thinsp;UU.
              </p>
            </div>

            {/* Right: Intro + badges */}
            <div className="text-center md:text-left" data-id="element-24">
              <h2 className="text-3xl md:text-4xl font-serif text-inkova-primary mb-4 leading-tight" data-id="element-25">
                No somos teoría. Somos el proceso que necesitas para crear tu
                empresa&nbsp;bien.
              </h2>
              <p className="text-gray-600 font-light mb-4 max-w-lg" data-id="element-26">
                Acompañamos a emprendedores latinos a formalizar su negocio en
                EE.&thinsp;UU. con orden, presencia profesional y
                sin&nbsp;improvisar.
              </p>
              <p className="text-inkova-primary font-semibold mb-6 max-w-lg" data-id="element-27">
                Guía. Estructura. Dirección.
              </p>
              <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-28">
                <span className="inline-flex items-center bg-transparent text-inkova-primary text-sm font-medium px-4 py-2 rounded-full border border-[#C9A84C]" data-id="element-29">
                  +8 años administrando empresas en&nbsp;EE.&thinsp;UU.
                </span>

                <span className="inline-flex items-center bg-transparent text-inkova-primary text-sm font-medium px-4 py-2 rounded-full border border-[#C9A84C]" data-id="element-30">
                  Acompañamiento en español para emprendedores&nbsp;latinos
                </span>
              </div>
              <p className="text-gray-500 font-light text-sm mt-6 max-w-lg italic" data-id="element-31">
                Inkova también se apoya en una red de aliados profesionales en
                contabilidad, legal y sistemas, para brindarte un acompañamiento
                más completo según la etapa y necesidades de tu&nbsp;negocio.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* PART 2 — Stats bar */}
      <div className="py-14 bg-inkova-primary" data-id="element-32">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="grid grid-cols-3 gap-6 text-center" data-id="element-34">
            <div data-id="element-35">
              <p className="text-4xl md:text-5xl font-bold text-inkova-accent font-serif" data-id="element-36">
                8+
              </p>
              <p className="text-sm md:text-base text-white font-medium mt-1" data-id="element-37">
                años de experiencia
              </p>
              <p className="text-sm text-gray-300 font-light mt-1" data-id="element-38">
                Asesorando negocios en&nbsp;EE.&thinsp;UU.
              </p>
            </div>
            <div data-id="element-39">
              <p className="text-4xl md:text-5xl font-bold text-inkova-accent font-serif" data-id="element-40">
                🤝
              </p>
              <p className="text-sm md:text-base text-white font-medium mt-1" data-id="element-41">
                Red de aliados profesionales
              </p>
              <p className="text-sm text-gray-300 font-light mt-1" data-id="element-42">
                Contabilidad, legal y&nbsp;sistemas
              </p>
            </div>
            <div data-id="element-43">
              <p className="text-4xl md:text-5xl font-bold text-inkova-accent font-serif" data-id="element-44">
                🇪🇸
              </p>
              <p className="text-sm md:text-base text-white font-medium mt-1" data-id="element-45">
                Proceso guiado en español
              </p>
              <p className="text-sm text-gray-300 font-light mt-1" data-id="element-46">
                Paso a paso para emprendedores&nbsp;latinos
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* PART 4 — Quotes */}
      <div className="py-16 bg-white" data-id="element-47">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="border-l-4 border-inkova-accent bg-inkova-light rounded-r-2xl p-6 md:p-8 space-y-4" data-id="element-49">
            <p className="text-inkova-primary italic font-serif text-base md:text-lg leading-relaxed" data-id="element-50">
              "Inkova no nació de la teoría. Nació de empezar, equivocarse
              y&nbsp;volver a&nbsp;comenzar."
            </p>
            <p className="text-inkova-primary italic font-serif text-base md:text-lg leading-relaxed" data-id="element-51">
              "Y de entender que el emprendedor latino merece más que una
              respuesta genérica en&nbsp;Google."
            </p>
            <p className="text-inkova-primary italic font-serif text-base md:text-lg leading-relaxed" data-id="element-52">
              "Merece acompañamiento real. Merece claridad. Merece un negocio
              construido con&nbsp;base."
            </p>
            <p className="text-inkova-primary font-bold font-serif text-base md:text-lg not-italic pt-2" data-id="element-53">
              Eso es lo que construimos en&nbsp;Inkova.
            </p>
          </motion.div>

          {/* WhatsApp button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-center mt-8" data-id="element-54">
            <a href="https://wa.me/17863037695" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-[#25D366] text-white font-bold text-base hover:bg-[#1ebe5a] transition-colors duration-300 shadow-lg" data-id="element-55">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-56">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-57" />
              </svg>
              Escríbeme directo — +1&nbsp;(786)&nbsp;303‑7695
            </a>
          </motion.div>
        </div>
      </div>

      {/* PART 5 — Closing phrase */}
      <div className="py-16 bg-gradient-to-br from-[#5a4579] to-[#3A2558]" data-id="element-58">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center" data-id="element-60">
            <p className="text-xl md:text-2xl lg:text-3xl font-serif font-bold text-white leading-relaxed" data-id="element-61">
              Te acompaño desde la idea inicial hasta que tu&nbsp;negocio está
              listo para&nbsp;operar.
            </p>
            <div className="w-20 h-1 bg-inkova-accent mx-auto rounded-full mt-6" data-id="element-62"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}